export default "__VITE_ASSET__DibWPLm1__"